var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHotels(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 96,
    viewBox: "0 0 81 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.27586 96H72C76.5633 96 80.2759 92.2875 80.2759 87.7241V8.27586C80.2759 3.71255 76.5633 0 72 0H8.27586C3.71255 0 0 3.71255 0 8.27586V87.7241C0 92.2875 3.71255 96 8.27586 96ZM3.31034 8.27586C3.31034 5.53821 5.53821 3.31034 8.27586 3.31034H26.2113H32.347C32.347 3.31034 33.077 3.31034 33.5172 3.31034C33.9575 3.31034 46.7586 3.31034 46.7586 3.31034H47.9288H54.0646H72C74.7377 3.31034 76.9655 5.53821 76.9655 8.27586V87.7241C76.9655 90.4618 74.7377 92.6897 72 92.6897H8.27586C5.53821 92.6897 3.31034 90.4618 3.31034 87.7241V8.27586Z",
    fill: "url(#paint0_linear_4051_32239)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2759 34.4138H37.1379C38.0532 34.4138 38.7931 33.6739 38.7931 32.7586V12.8966C38.7931 11.9812 38.0532 11.2414 37.1379 11.2414H17.2759C16.3605 11.2414 15.6207 11.9812 15.6207 12.8966V32.7586C15.6207 33.6739 16.3605 34.4138 17.2759 34.4138ZM18.931 14.5517H35.4828V31.1034H18.931V14.5517Z",
    fill: "url(#paint1_linear_4051_32239)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7586 14.5517H63C63.9153 14.5517 64.6552 13.8119 64.6552 12.8966C64.6552 11.9812 63.9153 11.2414 63 11.2414H46.7586C45.8433 11.2414 45.1034 11.9812 45.1034 12.8966C45.1034 13.8119 45.8433 14.5517 46.7586 14.5517Z",
    fill: "url(#paint2_linear_4051_32239)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7586 21.1724H63C63.9153 21.1724 64.6552 20.4326 64.6552 19.5172C64.6552 18.6019 63.9153 17.8621 63 17.8621H46.7586C45.8433 17.8621 45.1034 18.6019 45.1034 19.5172C45.1034 20.4326 45.8433 21.1724 46.7586 21.1724Z",
    fill: "url(#paint3_linear_4051_32239)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7586 27.7931H56.3793C57.2946 27.7931 58.0345 27.0532 58.0345 26.1379C58.0345 25.2226 57.2946 24.4828 56.3793 24.4828H46.7586C45.8433 24.4828 45.1034 25.2226 45.1034 26.1379C45.1034 27.0532 45.8433 27.7931 46.7586 27.7931Z",
    fill: "url(#paint4_linear_4051_32239)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2759 60.8966H37.1379C38.0532 60.8966 38.7931 60.1567 38.7931 59.2414V39.3793C38.7931 38.464 38.0532 37.7241 37.1379 37.7241H17.2759C16.3605 37.7241 15.6207 38.464 15.6207 39.3793V59.2414C15.6207 60.1567 16.3605 60.8966 17.2759 60.8966ZM18.931 41.0345H35.4828V57.5862H18.931V41.0345Z",
    fill: "url(#paint5_linear_4051_32239)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7586 41.0345H63C63.9153 41.0345 64.6552 40.2946 64.6552 39.3793C64.6552 38.464 63.9153 37.7241 63 37.7241H46.7586C45.8433 37.7241 45.1034 38.464 45.1034 39.3793C45.1034 40.2946 45.8433 41.0345 46.7586 41.0345Z",
    fill: "url(#paint6_linear_4051_32239)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7586 47.6552H63C63.9153 47.6552 64.6552 46.9153 64.6552 46C64.6552 45.0847 63.9153 44.3448 63 44.3448H46.7586C45.8433 44.3448 45.1034 45.0847 45.1034 46C45.1034 46.9153 45.8433 47.6552 46.7586 47.6552Z",
    fill: "url(#paint7_linear_4051_32239)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7586 54.2759H56.3793C57.2946 54.2759 58.0345 53.536 58.0345 52.6207C58.0345 51.7054 57.2946 50.9655 56.3793 50.9655H46.7586C45.8433 50.9655 45.1034 51.7054 45.1034 52.6207C45.1034 53.536 45.8433 54.2759 46.7586 54.2759Z",
    fill: "url(#paint8_linear_4051_32239)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2759 87.3793H37.1379C38.0532 87.3793 38.7931 86.6395 38.7931 85.7241V65.8621C38.7931 64.9468 38.0532 64.2069 37.1379 64.2069H17.2759C16.3605 64.2069 15.6207 64.9468 15.6207 65.8621V85.7241C15.6207 86.6395 16.3605 87.3793 17.2759 87.3793ZM18.931 67.5172H35.4828V84.069H18.931V67.5172Z",
    fill: "url(#paint9_linear_4051_32239)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7586 67.5172H63C63.9153 67.5172 64.6552 66.7774 64.6552 65.8621C64.6552 64.9468 63.9153 64.2069 63 64.2069H46.7586C45.8433 64.2069 45.1034 64.9468 45.1034 65.8621C45.1034 66.7774 45.8433 67.5172 46.7586 67.5172Z",
    fill: "url(#paint10_linear_4051_32239)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7586 74.1379H63C63.9153 74.1379 64.6552 73.3981 64.6552 72.4828C64.6552 71.5674 63.9153 70.8276 63 70.8276H46.7586C45.8433 70.8276 45.1034 71.5674 45.1034 72.4828C45.1034 73.3981 45.8433 74.1379 46.7586 74.1379Z",
    fill: "url(#paint11_linear_4051_32239)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7586 80.7586H56.3793C57.2946 80.7586 58.0345 80.0188 58.0345 79.1035C58.0345 78.1881 57.2946 77.4483 56.3793 77.4483H46.7586C45.8433 77.4483 45.1034 78.1881 45.1034 79.1035C45.1034 80.0188 45.8433 80.7586 46.7586 80.7586Z",
    fill: "url(#paint12_linear_4051_32239)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4051_32239",
    x1: 40.138,
    y1: 3.46789,
    x2: 40.138,
    y2: 93.2307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC5C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    stopColor: "#F35E85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    stopColor: "#D9659B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#B070BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#777FF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A82FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4051_32239",
    x1: 40.138,
    y1: 3.46789,
    x2: 40.138,
    y2: 93.2307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC5C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    stopColor: "#F35E85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    stopColor: "#D9659B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#B070BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#777FF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A82FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4051_32239",
    x1: 40.138,
    y1: 3.46789,
    x2: 40.138,
    y2: 93.2307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC5C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    stopColor: "#F35E85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    stopColor: "#D9659B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#B070BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#777FF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A82FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4051_32239",
    x1: 40.138,
    y1: 3.46789,
    x2: 40.138,
    y2: 93.2307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC5C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    stopColor: "#F35E85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    stopColor: "#D9659B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#B070BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#777FF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A82FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4051_32239",
    x1: 40.138,
    y1: 3.46789,
    x2: 40.138,
    y2: 93.2307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC5C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    stopColor: "#F35E85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    stopColor: "#D9659B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#B070BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#777FF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A82FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4051_32239",
    x1: 40.138,
    y1: 3.46789,
    x2: 40.138,
    y2: 93.2307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC5C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    stopColor: "#F35E85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    stopColor: "#D9659B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#B070BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#777FF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A82FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4051_32239",
    x1: 40.138,
    y1: 3.46789,
    x2: 40.138,
    y2: 93.2307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC5C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    stopColor: "#F35E85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    stopColor: "#D9659B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#B070BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#777FF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A82FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4051_32239",
    x1: 40.138,
    y1: 3.46789,
    x2: 40.138,
    y2: 93.2307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC5C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    stopColor: "#F35E85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    stopColor: "#D9659B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#B070BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#777FF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A82FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4051_32239",
    x1: 40.138,
    y1: 3.46789,
    x2: 40.138,
    y2: 93.2307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC5C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    stopColor: "#F35E85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    stopColor: "#D9659B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#B070BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#777FF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A82FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4051_32239",
    x1: 40.138,
    y1: 3.46789,
    x2: 40.138,
    y2: 93.2307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC5C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    stopColor: "#F35E85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    stopColor: "#D9659B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#B070BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#777FF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A82FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4051_32239",
    x1: 40.138,
    y1: 3.46789,
    x2: 40.138,
    y2: 93.2307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC5C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    stopColor: "#F35E85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    stopColor: "#D9659B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#B070BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#777FF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A82FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4051_32239",
    x1: 40.138,
    y1: 3.46789,
    x2: 40.138,
    y2: 93.2307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC5C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    stopColor: "#F35E85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    stopColor: "#D9659B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#B070BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#777FF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A82FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4051_32239",
    x1: 40.138,
    y1: 3.46789,
    x2: 40.138,
    y2: 93.2307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC5C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    stopColor: "#F35E85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    stopColor: "#D9659B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#B070BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#777FF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A82FB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotels);
export default __webpack_public_path__ + "static/media/hotels.12cdb007588577a1e93d51b1b09d7ca4.svg";
export { ForwardRef as ReactComponent };